/// <reference path="i18n.ts" />

module YVR.Utilities.Dates {
	//Dependencies

	import i18n = YVR.Utilities.I18n;

	// Constants

	export const CONSANTS = {
		SHORT_TIME: 'HH:mm',
		SHORT_DATE: 'dd/mm/yyyy',
		LONG_DATE: 'dddd, D MMM Y',
		MONTH_DAY: 'MMM D',
		EDM_DATE: 'YYYY-MM-DDTHH:mm:ss',
		ZONE: 'America/Vancouver',
		SHORT_DATE_TIME: 'MMMM D, HH:mm',
		FULL_MONTH_DAY : 'MMMM D'
	};


	//#region Private Functions

	function main() {
		// addZone();
		setLocale();
	}


	/**
	 * Adds the America/Vancouver time zone to moment.
	 */
	// function addZone() {
	// 	(window as any).moment.tz.add('America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0');
	// }


	/**
	 * Set the currnet locale based on language.
	 */
	function setLocale() {
		(window as any).moment.locale(i18n.getCurrentLanguage().toLowerCase());
	}

	//#endregion


	//#region Public Functions

	/**
	 * Converts a string to a time in the Vancouver time zone.
	 */
	export function convertTime(time) {
		return (window as any).moment.tz(time, CONSANTS.ZONE);
	}


	/**
	 * Get the current time in the Pacific timezone.
	 * @returns {obj} The current time in the Pacific timezone.
	 */
	export function getCurrentTime() {
		return (window as any).moment().tz(CONSANTS.ZONE).clone();
	}


	/**
	 * Get the current time in EDM format.
	 * @returns {string} The current time in EDM format.
	 */
	export function getCurrentEDMTime() {
		return formatEDMTime(getCurrentTime());
	}


	/**
	 * Get the current time in the short format.
	 * @returns {string} The current time in the short format.
	 */
	export function getCurrentShortTime() {
		return formatShortTime(getCurrentTime());
	}


	/**
	 * Get a date object from a date and time string fields.
	 * @param {string} date A date formatted in dd/mm/yyyy
	 * @param {string} time A time formatted in HH:mm
	 */
	export function getDatetimeFromStrings(date, time) {
		date = date.split('/');
		time = time.split(':');

		return new Date(date[2], date[1] - 1, date[0], time[0], time[1]);
	}


	/**
	 * Formats a given date to EDM format.
	 * @param {obj} date A date object or string that represents a date.
	 * @returns {string} A formated date string in the EDM format.
	 */
	export function formatEDMTime(date) {
		return (window as any).moment(date).format(CONSANTS.EDM_DATE);
	}


	/**
	 * Formats a given date to ISO 8601 format.
	 * @param {obj} date A date object or string that represents a date.
	 * @returns {string} A formated date string in the EDM format.
	 */
	export function formatISOTime(date) {
		return convertTime(date).format();
	}


	/**
	 * Shows the short time format.
	 * @param {obj} date A date object or string that represents a date.
	 * @returns {string} A formated date string with our preferred short format.
	 */
	export function formatShortTime(date) {
		return (window as any).moment(date).format(CONSANTS.SHORT_TIME);
	}


	/**
	 * Shows the date in a month day format.
	 * @param {obj} date A date object or string that represents a date.
	 * @returns {string} A formated date string with our preferred long format.
	 */
	export function formatMonthDay(date) {
		return (window as any).moment(date).format(CONSANTS.MONTH_DAY);
	}


	/**
	 * Shows the long ate format.
	 * @param {obj} date A date object or string that represents a date.
	 * @returns {string} A formated date string with our preferred long format.
	 */
	export function formatLongDate(date) {
		return (window as any).moment(date).format(CONSANTS.LONG_DATE);
	}

	/**
	 * Shows the full month, day, and time format.
	 * @param {obj} date A date object or string that represents a date.
	 * @returns {string} A formated date string with our preferred format.
	 */
	export function formatShortDateTime(date) {
		return (window as any).moment(date).format(CONSANTS.SHORT_DATE_TIME);
	}

	/**
	 * Shows the full month, day, and time format.
	 * @param {obj} date A date object or string that represents a date.
	 * @returns {string} A formated date string with our preferred format.
	 */
	export function formatFullMonthDay(date) {
		return (window as any).moment(date).format(CONSANTS.FULL_MONTH_DAY);
	}


	//#endregion


	main();
}
